import { GraphsCard } from "@/components/cards/GraphsCard";
import styles from "./css/ElectricityContent.module.css";
import { AlternativeData } from "@/types/alternative";
import { FuturePowerGrid } from "./FuturePowerGrid";
import { CurrentPowerGrid } from "./CurrentPowerGrid";
import { UndergoundElecticalGrid } from "./UndergoundElecticalGrid";
import { Project } from "@/types";
import { useTranslation } from "react-i18next";

interface ElectricityContentProps {
    alternative: AlternativeData;
    project: Project;
    numberOfCompare?: number;
}

export const ElectricityContent = ({alternative, project, numberOfCompare = 0}: ElectricityContentProps) => {
    const { t } = useTranslation('ElectricityContent');
    
    const formatNumber = (value: number | string | undefined | null): string => {
        if (value === null || value === undefined || value === '') return '0';
        const num = typeof value === 'string' ? parseFloat(value) : value;
        if (isNaN(num)) return '0';
        
        if (Math.abs(num) >= 1000000) {
            const millions = num / 1000000;
            return millions % 1 === 0 ? `${millions}M` : `${millions.toFixed(1)}M`;
        }
        
        if (Math.abs(num) >= 1000) {
            const thousands = num / 1000;
            return thousands % 1 === 0 ? `${thousands}K` : `${thousands.toFixed(1)}K`;
        }
        
        return num % 1 === 0 ? num.toString() : num.toFixed(2);
    };

    return (
        <div className={numberOfCompare === 2 ? styles.content : styles.contentSmall}>
            <GraphsCard 
                title={t('currentStatus')}
                children={<CurrentPowerGrid data={alternative.electrical_infrastructure} />}
                setFavourite={() => {}}
                id="futureDemand"
                isFavourite={false}
                showFavorite={false}
                numberOfCompare={3}
                size="verySmall"
            />
            <GraphsCard 
                title={t('futureStatus')}
                children={<FuturePowerGrid data={alternative.electrical_infrastructure} />}
                setFavourite={() => {}}
                id="futureDemand"
                isFavourite={false}
                showFavorite={false}
                numberOfCompare={3}
            />
            <GraphsCard
                title={t('burialInfrastructure')}
                children={
                    <UndergoundElecticalGrid
                    data={project.buried_electric_infrastructure}
                    />
                }
                setFavourite={() => {}}
                id="underground_electrical_infrastructure"
                isFavourite={false}
                showFavorite={false}
                numberOfCompare={3}
                />
        </div>
    );
};